<template>
    <Modal
        :open="open"
        :show-close-icon="true"
        @close="closeModal"
        :is-card="true"
        :narrow="false"
        :close-has-background="true"
        :modal-type="'priceAlert'"
    >
        <template
            v-if="!inMyAccountArea"
            v-slot:image
        >
            <div class="price-alert-modal__image-wrapper">
                <picture>
                    <source
                        srcset="/images/my-account/price-alerts/modal-image@1x.webp 1x, /images/my-account/price-alerts/modal-image@2x.webp 2x"
                        type="image/webp"
                    />
                    <img
                        class="price-alert-modal__image"
                        srcset="/images/my-account/price-alerts/modal-image@1x.jpg 1x, /images/my-account/price-alerts/modal-image@2x.jpg 2x"
                    />
                </picture>
            </div>
        </template>
        <div v-if="validateEmailMessage">
            <div>
                <h1>Confirm your email address.</h1>
                <p>Please check your inbox to confirm your email address and continue setting up your account.</p>
            </div>

            <p >Not received an email? Click the button below to resend your confirmation email</p>
            <div class="price-alert-modal__inner--btn-area">
                <a href="" class="btn btn--primary-inverted" @click.prevent="resendVerificationLink">Resend Verification Email</a>
                <a href="" @click.prevent="backToPriceAlert" class="link link--secondary link--has-icon-reverse link--centered">BACK TO PRICE ALERT</a>
            </div>
        </div>
        <form
            @submit.prevent="submit"
            ref="form"
            v-else
        >
            <div v-if="vehicle && displayCreated === false" class="price-alert-modal__inner" :class="{ 'price-alert-modal__inner--my-account': inMyAccountArea }">
                <div v-if="verificationEmail" class="validation-error__ul ul__no-bullet">
                    <li class="validation-error__li validation-error--success">
                        Verification email sent.
                    </li>
                </div>
                <h2 class="price-alert-modal__edit-vehicle-h2">
                    <span v-if="priceAlert">Edit</span><span v-else>Create</span> Your Price Alert
                </h2>
                Receive a notification when the price of this {{ vehicle.manufacturer }} {{ vehicle.model }} changes.
                <div class="price-alert-modal__title-row">
                    <a
                        :href="`/used-vehicles/${vehicle.id}/${vehicle.slug}`"
                        class="price-alert__title-area"
                    >
                        <h2 class="price-alert-modal__title">{{ vehicle.manufacturer }} {{ vehicle.model }}</h2>
                    </a>
                    <div class="price-alert-modal__price">
                        Current Price
                        <span class="price-alert-modal__price-label price-alert-modal__price-label--orange">{{
                            `£${vehicle.price_formatted}` }}</span>
                    </div>
                </div>
                <div
                    v-if="statusMessage"
                    class="validation-error__ul ul__no-bullet"
                >
                    <li class="validation-error__li validation-error--success">
                        {{ statusMessage }}
                    </li>
                </div>
                <div class="price-alert-modal__amount-container">
                    <div class="price-alert-modal__frequency-container">
                        <p class="price-alert-modal__title">How often would you like to receive a price alert?</p>
                        <div class="price-alert-modal__frequencies-grid">
                            <div
                                v-for="frequency in ['instant', 'daily', 'weekly']"
                                :key="frequency"
                                :class="{ 'price-alert-modal__frequency-option': true, 'price-alert-modal__selected-frequency': frequency === chosenFrequency }"
                                @click="handleFrequencySelection(frequency)"
                            >
                                <span v-if="frequency === 'instant'">Instantly</span>
                                <span v-else>
                                    {{ frequency.charAt(0).toUpperCase() + frequency.slice(1) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- PRICE ALERT BASED ON PRICE WORK -->
                <!-- <div class="price-alert-modal__amount-container">
                    <div class="price-alert-modal__picker">
                        <div
                            class="price-alert-modal__amount-btn"
                            @mousedown="startChangingPrice('increase')"
                            @mouseup="stopChangingPrice"
                            @mouseleave="stopChangingPrice"
                        >-</div>
                        <div>
                            <h4 class="price-alert-modal__amount-container--heading">Notification Price</h4>
                            <input
                                class="price-alert-modal__input form-control"
                                :placeholder="formattedAmountDifference"
                                :value="formatPrice(targetPrice)"
                                @input="handlePriceInput"
                                type="text"
                            >
                        </div>
                        <div
                            class="price-alert-modal__amount-btn"
                            @mousedown="startChangingPrice('subtract')"
                            @mouseup="stopChangingPrice"
                            @mouseleave="stopChangingPrice"
                        >+</div>
                    </div>
                </div>
                <div class="price-alert-modal__price-change">
                    You will be notified when the price changes by:
                    <div class="price-alert-modal__amount-changed">
                        {{ formatPrice(Math.abs(difference)) }}
                    </div>
                </div> -->
                <div class="price-alert-modal__btn-area">
                    <button
                        class="btn btn--primary btn--min-width"
                    >Submit</button>
                    <a
                        v-if="!inMyAccountArea && priceAlert"
                        @click="viewAccount"
                        class="link link--secondary link--is-button link--has-icon link--centered"
                    >
                        View in account
                    </a>
                    <a
                        v-if="priceAlert"
                        @click="cancelAlert()"
                        class="link link--is-button link--has-icon link--alert link--centered"
                    >Cancel alert</a>
                </div>
            </div>
            <div v-else class="price-alert-modal__inner">
                <h1 class="price-alert-modal__h1">Price Alert Created</h1>
                <div class="price-alert-modal__body-item">
                    <p class="price-alert-modal__subheading" >
                        We will notify you when the price of this vehicle changes <span v-if="this.priceAlert.frequency === 'instant'">instantly</span><span v-else>{{ this.priceAlert.frequency }}</span>. To continue discovering this vehicle or to view your price alert, please use the buttons below.
                    </p>
                </div>

                <div class="price-alert-modal__btn-area">
                    <a @click="viewAccount" type="button" class="btn btn--primary btn--full-width">VIEW PRICE ALERT</a>
                    <a href="" @click.prevent="closeModal" class="link link--secondary link--has-icon-reverse link--centered ">BACK TO VEHICLE</a>
                </div>
            </div>
        </form>
    </Modal>
</template>

<script>
import Modal from "../../../core/components/Modal.vue";
import { customEvent } from '../../../modules/tracking/AnalyticsEvents';

export default {
    props: {
        open: {
            default: false,
        },
        priceAlert: {
            default: null,
            required: false,
        },
        vehicleData: {
            required: false,
        },
        inMyAccountArea: {
            default: true,
            required: false,
        }
    },
    components: {
        Modal,
    },
    data() {
        return {
            validator: null,
            loading: false,
            vehicle: null,
            difference: 100,
            statusMessage: null,
            validateEmailMessage:null,
            // targetPrice: null,
            // priceLimit:999999,
            displayCreated: false,
            chosenFrequency: this.priceAlert ? this.priceAlert.frequency : 'instant',
            verificationEmail:false,
        };
    },
    computed: {
        formattedAmountDifference() {
            return this.formatPrice(this.amountDifference);
        },
        amountDifference() {
            return this.vehicle ? this.vehicle.price - this.difference : 0;
        },
    },
    methods: {
        backToPriceAlert(){
            this.displayCreated = false,
            this.validateEmailMessage = false
            this.verificationEmail = false
        },

        viewAccount(){
            axios.get('/my-account/price-alerts')
                .then(response => {
                    window.location.href = '/my-account/price-alerts';
                })
                .catch(error => this.handleError(error));
        },

        handleFrequencySelection(frequency) {
            this.statusMessage = null;
            this.chosenFrequency = frequency;
        },

        // changePrice(type) {
        //     const adjustment = type === 'subtract' ? -100 : 100;
        //     let newPrice = this.difference + adjustment;
        //     this.targetPrice = Math.max(0, Math.min(this.vehicle.price - newPrice, this.priceLimit));
        //     if (this.targetPrice >= this.priceLimit || this.targetPrice < 0) {
        //         this.stopChangingPrice();
        //     }
        //     this.difference = newPrice;
        // },

        // startChangingPrice(type) {
        //     if ((type === 'increase' && this.targetPrice <= 0) || (type === 'subtract' && this.targetPrice >= this.priceLimit)) {
        //         this.stopChangingPrice();
        //         return;
        //     }
        //     this.changePrice(type);

        //     this.intervalId = setInterval(() => {
        //         if ((type === 'increase' && this.targetPrice <= 0) || (type === 'subtract' && this.targetPrice >= this.priceLimit)) {
        //             this.stopChangingPrice();
        //         }else{
        //             this.changePrice(type);
        //         }
        //     }, 100);
        // },

        // stopChangingPrice() {
        //     clearInterval(this.intervalId);
        //     this.intervalId = null;
        // },

        // formatPrice(value) {
        //     if (value === null || value === undefined) return '£0';
        //     return '£' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        // },

        // parsePrice(value) {
        //     return parseInt(value.replace(/[^0-9]/g, ''), 10) || 0;
        // },

        // handlePriceInput(event) {
        //     const parsedValue = this.parsePrice(event.target.value);
        //     const limitedValue = Math.min(parsedValue, this.priceLimit);
        //     this.targetPrice = limitedValue;
        // },

        closeModal(response) {
            this.statusMessage = ''
            this.displayCreated = false;
            if(this.inMyAccountArea){
                this.$emit("close-modal", response);
            }else{
                try {
                    this.$store.commit("Layout/setShowPriceAlertModal", false);
                } catch (e) {
                    this.$emit("close-modal", response);
                }
            }
        },

        async submitAlert(url, method, data, successAction) {
            if (method !== 'delete' && !await this.validator.isValid()) {
                return;
            }
            this.validator.preventInput();
            axios({ method: method, url: url, ...(method === 'delete' ? { data } : { data }) })
                .then(response => this.handleResponse(response, successAction))
                .catch(error => this.handleError(error));
        },

        create() {
            const data = {
                alert_id: this.vehicle.id,
                current_price: this.vehicle.price,
                // target_price: this.targetPrice,
                // difference: this.difference,
                frequency: this.chosenFrequency,
                type: 'used',
            };
            this.submitAlert('/my-account/price-alert', 'post', data, 'Created Price alert');
        },

        update() {
            const data = {
                alert_id: this.priceAlert.id,
                current_price: this.vehicle.price,
                // target_price: this.targetPrice,
                // difference: this.difference,
                frequency: this.chosenFrequency
            };
            this.submitAlert('/my-account/price-alert', 'patch', data, 'Edit Price alert');
        },

        submit() {
            this.verificationEmail = null
            if (this.priceAlert === null) {
                this.create();
            } else {
                this.update();
            }
        },

        cancelAlert() {
            const data = {
                alert_id: this.priceAlert.id
            };
            this.submitAlert('/my-account/price-alert', 'delete', data, 'Delete Price alert');
        },

        handleResponse(response, action) {
            this.validator.successResponse();
            this.validator.allowInput();
            this.statusMessage = action.includes("Created") ? "Price Alert Created" : "Price Alert Updated";
            if(response.data.created === true){
                this.displayCreated = true
            }
            this.$emit('alert-updated', response.data);
            if (this.inMyAccountArea !== false) {
                this.closeModal(response.data);
            }
        },

        handleError(error) {
            if (error.response && error.response.data.message === 'Your email address is not verified.') {
                console.error(error);
                this.validateEmailMessage = "You must validate your email before creating a price alert"
                this.validator.errorResponse();
            } else {
                console.error(error);
                this.validator.errorResponse(error);
            }
        },

        resendVerificationLink() {
            axios.post('/email/resend')
                .then(response => {
                    this.validateEmailMessage = false;
                    this.verificationEmail = true
                })
                .catch(error => this.handleError(error));
        },

        setup() {
            const defaultDifference = 100;

            if (this.priceAlert) {
                this.vehicle = this.priceAlert.alertable
                // this.difference = this.priceAlert.difference
                // this.targetPrice = this.priceAlert.target_price
                this.validator = new ContactFormValidator({
                    vueForm: true,
                    redesign: true,
                    element: this.$refs["form"],
                });
            } else {
                this.vehicle = this.vehicleData
                // this.difference = defaultDifference;
                // this.targetPrice = this.vehicle.price - this.difference;
                this.validator = new ContactFormValidator({
                    vueForm: true,
                    redesign: true,
                    element: this.$refs["form"],
                });
            }
        }
    },
    // watch: {
    //     targetPrice(newValue) {
    //         this.difference = this.vehicle.price - newValue;
    //     },
    // },
    mounted() {
       this.setup();
    },
    created() {
        this.setup();
    },
    beforeDestroy() {
        this.displayCreated = false;
        clearInterval(this.intervalId);
        this.closeModal(null);
    }
};
</script>

<style lang="scss">

@import "../../../../sass/redesign/my-account/price-alerts-modal";
</style>



// WEBPACK FOOTER //
// resources/assets/js/my-account/components/price-alerts/PriceAlertModal.vue